import { MigrationItem } from '../../components/ListItemCard';

const hasValidUser = (migrationValue: MigrationItem): boolean =>
  migrationValue.targetUserId !== null;

export default hasValidUser;
